import React from 'react'
import { useIntl } from 'react-intl'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import config from 'constants/config'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import styled from 'styled-components'
import { rem } from 'polished'
import { getSVGImageUrl } from 'lib/image/imageUtils'

const Slide = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: ${rem(150)};
  height: ${rem(74)};
  background-color: #fff;
`

function PartnerCarousel() {
  const intl = useIntl()
  const isMobileScreen = useScreenSizeOnly('mobile')
  const itemsToShow = isMobileScreen ? 3 : 7

  return <CardCarousel pageSize={itemsToShow} gap={12}>
    {config.logoImages?.map((logo) => (
      <Slide key={logo.name}>
        <img
          src={getSVGImageUrl(logo.id)}
          alt={intl.formatMessage({
            id: 'x8b8MS82a-K2uDam9LZG',
            defaultMessage: '{logoName} logo',
            description: 'Accessibility alt text for a partner brand logo image',
          }, { logoName: logo.name })}
          width={logo.width}
        />
      </Slide>
    ))}
  </CardCarousel>
}

export default PartnerCarousel
